import moment from "moment";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Dialog, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import "./ChannelDetailsDialog.css";
import "../Components/Components.css";

const ChannelDetailsDialog = ({
  isOpen,
  selectedChannel,
  setIsChannelDetailsDialogShown,
  setSelectedChannel,
}) => {
  const columns = [
    {
      field: "ContactID",
      flex: 1,
      headerName: "Contact ID",
    },

    {
      field: "ContactName",
      flex: 1,
      headerName: "Contact Name",
    },

    {
      field: "ContactNumber",
      flex: 1,
      headerName: "Contact Number",
    },

    {
      field: "ReceivedTime",
      flex: 1,
      headerName: "Received Time",

      renderCell: (params) =>
        params.row.ConnectTime
          ? moment(params.row.ConnectTime).format("DD-MMM-yyyy HH:mm:ss")
          : "",
    },

    {
      field: "RespondedTime",
      flex: 1,
      headerName: "Responded Time",

      renderCell: (params) =>
        params.row.DisconnectTime
          ? moment(params.row.DisconnectTime).format("DD-MMM-yyyy HH:mm:ss")
          : "",
    },

    {
      field: "ChatDuration",
      flex: 1,
      headerName: "Chat Duration",

      renderCell: (params) =>
        moment
          .utc(
            moment.duration(params.row.TalkDuration, "seconds").asMilliseconds()
          )
          .format("HH:mm:ss"),
    },

    {
      field: "Status",
      flex: 1,
      headerName: "Status",
    },

    {
      field: "ByAgent",
      flex: 1,
      headerName: "By Agent",
    },
  ];

  const dummy = [
    {
      id: 1,
      ContactID: "84847",
      ContactName: "Marco",
      ContactNumber: "081234567890",
      ReceivedTime: "2024-03-18T17:01:24.407Z",
      RespondedTime: "2024-03-18T17:01:24.407Z",
      ChatDuration: 0,
      Status: "Inbound",
      ByAgent: "Tele One",
    },

    {
      id: 2,
      ContactID: "84848",
      ContactName: "Polo",
      ContactNumber: "081234567890",
      ReceivedTime: "2024-03-18T17:01:24.407Z",
      RespondedTime: "2024-03-18T17:01:24.407Z",
      ChatDuration: 0,
      Status: "Outbound",
      ByAgent: "Tele Two",
    },
  ];

  const handleClose = () => {
    setIsChannelDetailsDialogShown(false);
    setSelectedChannel(null);
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog channel-details-dialog"
      fullWidth
      maxWidth="xxl"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <div className="dialog-content">
          <IconButton className="close-button" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>

          <h2 className="title">
            {`${
              selectedChannel?.phoneNumber
                ? selectedChannel.phoneNumber + " - "
                : ""
            }${selectedChannel?.name}`}{" "}
            <span>({selectedChannel?.channel})</span>
          </h2>

          <div className="table-container">
            <DataGrid
              className="table"
              columns={columns}
              disableColumnFilter
              disableColumnMenu
              disableSelectionOnClick
              rows={dummy}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ChannelDetailsDialog;
